import { ReportSectionArea as Component } from './component';
import Connector from './connector';
import { ConnectorProps } from './ReportSectionArea.proptype';

export interface ReportSectionAreaProps extends Omit<ConnectorProps, 'component'> {}

export const ReportSectionArea = (props: ReportSectionAreaProps) => <Connector {...props} component={Component} />;
